import React from "react";

/**
 * PageNotFound component that displays a message when a page cannot be found.
 * 
 * @returns {JSX.Element} The rendered page not found message.
 */
export function PageNotFound() {
  return (
    <>
      <div className="full-width-container">
        <h2 className="content-header">Sidan kunde inte hittas</h2>
      </div>
    </>
  );
}
